import { frontendURL } from '../../../helper/URLHelper';
import TemplatesIndex from './Index.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/templates'),
    name: 'templates_dashboard_index',
    component: TemplatesIndex,
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
  },
];

export default { routes };
